<template>
    <div v-if="showPopup()">
        <pop-up-modal-content
            :maxWidth="settings.max_width"
            :maxHeight="settings.max_height"
            :backgroundColor="settings.background_color"
            :justifyContentPopUp="settings.justify_content"
            :alignItemsPopUp="settings.align_items"
            :marginPopUp="settings.margin"

            :paddingPopUpBody="settings.body.padding"
            :overflowBodyPopUp="settings.body.overflow"
        >
            <div class="modal fade modal-coupon" style="opacity: 1"  tabindex="-1" role="dialog" id="modal-pop-up-coupon" aria-labelledby="modal-pop-up-coupon" aria-hidden="true" @click="closeModal()">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <i class="fas fa-times" @click="closeModal()"></i>
                        <div class="modal-body">
                            <a :href="pop_up.link" target="_self" @click="pop_up.link ? closeModal() : $event.preventDefault()">
                                <img :src="$pathFilesSystem+'/'+pop_up.image_path" :alt="pop_up.name" height="400" width="400" loading="lazy">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </pop-up-modal-content>
    </div>
</template>

<script>
import { CPopUpModalContent } from '../Styles/PopUp/styled'
import * as SessionStorageService from '../../services/SessionStorageService'

export default {
    name: 'PopUpCoupon',
    props: {
        pop_up: { required: true },
        set: { required: true },
        show_popup: { required: true }
    },
    components: {
        'pop-up-modal-content': CPopUpModalContent
    },
    data() {
        return {
            settings: {
                max_width: this.set?.max_width ?? '600px',
                max_height: this.set?.max_height ?? 'auto',
                background_color: this.set?.background_color ?? '#ffffff',
                justify_content: this.set?.justify_content ?? 'center',
                align_items: this.set?.align_items ?? 'start',
                margin: this.set?.margin ?? '20px',
                body: {
                    padding: '0px',
                    overflow: 'hidden'
                }
            }
        }
    },
    methods: {
        async closeModal() {
            $('#modal-pop-up-coupon').hide()
            const key = 'popup-coupon-'+ this.pop_up?.id;
            SessionStorageService.set(key, {showed: true})
        },
        showPopup() {
            const key = 'popup-coupon-'+ this.pop_up?.id;
            const getKey = SessionStorageService.get(key)
            return !getKey?.showed
        }
    }
}
</script>

<style scoped>
img {
    width: 100%;
}
</style>
